<template>
    <div style="background: rgba(0,0,0,255) !important;width:100%;height:100%;"

    >
        <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="">
            <source :src="require('../assets/white_flare.webm')" type="video/webm">

        </video>





        <v-row align="center" justify="center" style="margin-top:0px;height:100%;width:100%;">
            <v-col align="center" style="margin-top:0px;height:100%;width:100%;">
                <carousel :autoplayHoverPause=false :autoplayTimeout=25000 :loop=true :paginationEnabled=false :autoplay=true :per-page="1" :mouse-drag="false">

                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/logo.png')"
                                :height="972"
                                :width="700"
                                contain

                        ></v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/Giving-Gamers-Black.png')"
                                :height="972"
                                :width="1728"
                                contain

                        ></v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>

                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/alcatel.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/avalanche.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/esen.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/eset.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/Kappabar.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/learn2esport.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/Lenovo.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>

                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/noblechairs.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/playstation.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/samsung.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/sesf.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/xtrfy.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                    <slide>
                        <v-img
                                style="color:white;"
                                :src="require('../assets/givinggamers/msi.png')"
                                :height="972"
                                :width="1728"
                                contain>

                        </v-img>
                    </slide>
                </carousel>

            </v-col>

        </v-row>

        <v-row align="center" justify="center" style="">




        </v-row>
    </div>

</template>

<script>

    export default {
        name: "StaticCharity",
        data(){
            return{
                amount_donated:0,
                milestones:[5000,10000,25000,50000,75000,100000,150000,200000,250000,300000,350000,400000,450000,500000,550000,600000,1000000]
            }
        },
        computed:{
            percentage_donated:function(){


                return (this.amount_donated/this.current_milestone)*100;
            },
            current_milestone:function(){

                for(let i=0;i<this.milestones.length;i++){
                    if(this.amount_donated<this.milestones[i]){
                        return this.milestones[i]
                    }
                }
                return 2000000
            }
        },
        mounted:function(){

        },
        methods:{

        }


    }
</script>

<style>
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }
</style>
